module.exports = __webpack_public_path__ + "static/media/Public_41.a4f75d9d.jpg";